import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useListingStore } from '../stores/listingStore';
import { useBillingStore } from '../stores/billingStore';
import FullListingDetails from '../components/FullListingDetails';
import PremiumUpgradeOverlay from '../components/PremiumUpgradeOverlay';

const ListingDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuth();
  const { subscription } = useBillingStore();
  const { listings, favorites, toggleFavorite } = useListingStore();

  // Find the listing from our store
  const listing = listings.find(l => l.id === id);

  if (!listing) {
    navigate('/listings');
    return null;
  }

  // Check if user owns this listing
  const isOwner = user?.id === listing.ownerId;

  // Check if user has premium access
  const hasPremiumAccess = isOwner || (isAuthenticated && subscription?.status === 'active');

  // Show premium overlay if:
  // 1. User is not authenticated, or
  // 2. User is authenticated but doesn't have an active subscription
  // 3. User is not the owner of the listing
  if (!hasPremiumAccess) {
    return (
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="bg-white rounded-lg shadow-sm p-6">
            {/* Preview Content */}
            <div className="mb-6">
              <h1 className="text-2xl font-bold text-gray-900 mb-4">{listing.title}</h1>
              <p className="text-gray-600 mb-4">{listing.location}</p>
              <div className="text-2xl font-bold text-indigo-600">
                ${listing.price}/mo
              </div>
            </div>

            {/* Property Preview Image */}
            <div className="relative aspect-video w-full mb-6 rounded-lg overflow-hidden">
              <img 
                src={listing.images[0]} 
                alt={listing.title}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
            </div>

            {/* Premium Upgrade Overlay */}
            <PremiumUpgradeOverlay 
              onClose={() => navigate('/listings')}
              listingTitle={listing.title}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <FullListingDetails 
      listing={listing}
      isFavorite={favorites.includes(listing.id)}
      onToggleFavorite={() => toggleFavorite(listing.id)}
      isOwner={isOwner}
    />
  );
};

export default ListingDetails;